import * as React from 'react';
import { useTranslation } from 'react-i18next';
import StarIcon from '@mui/icons-material/Star';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import colors from 'src/assets/_util.scss';
import { AbstractCode } from 'src/types/insights';
import { useCodebookContext } from '../Catalog/CodebookProvider';
import CodeChip from '../Common/CodeChip';

interface BaseProps {
  code?: AbstractCode;
  codes: AbstractCode[];
  disabledCodes?: AbstractCode['id'][];
  onChange: (parentId: number) => void;
}

type Props = BaseProps;

const CodeSelect: React.FunctionComponent<Props> = (props: Props) => {
  const { code, codes, disabledCodes, onChange } = props;
  const { parentCodeId, setParentCodeId } = useCodebookContext();

  const { t } = useTranslation();
  const [codeId, setCodeId] = React.useState(
    `${
      code !== undefined && code.parent_id !== undefined ? code.parent_id : -1
    }`
  );
  const handleChange = (event: SelectChangeEvent) => {
    event.target.value === '-1' && setParentCodeId(undefined);
    setCodeId(event.target.value as string);
    onChange(Number(event.target.value));
  };

  const isParentCode = codes.some((c) => {
    if (code !== undefined) {
      return c.parent_id === code.id;
    }
  });

  return (
    <Box sx={{ minWidth: 360 }}>
      <FormControl fullWidth>
        <InputLabel id="code-select">{t('insights.code_parent')}</InputLabel>
        <Select
          disabled={isParentCode}
          label={t('insights.code_parent')}
          labelId="code-select"
          onChange={handleChange}
          value={
            parentCodeId !== undefined && codeId === '-1'
              ? String(parentCodeId)
              : codeId
          }
        >
          <MenuItem key={-1} value="-1">
            <CodeChip
              code={{
                name: t('insights.no_parent'),
                id: -1,
                color: '#ffffff',
                parentage: [-1],
                code_type: 'none',
              }}
            />
          </MenuItem>
          {codes.map((currentCode) => (
            <MenuItem
              disabled={
                (disabledCodes !== undefined &&
                  disabledCodes.indexOf(currentCode.id) !== -1) ||
                // (code !== undefined && currentCode.id === code.id) ||
                (code !== undefined && isParentCode)
              }
              key={currentCode.id}
              sx={{ pl: 2 + 4 * (currentCode.parentage || []).length }}
              value={currentCode.id}
            >
              <CodeChip code={currentCode} />
              {code !== undefined && currentCode.id === code.id && <StarIcon />}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {isParentCode && (
        <Typography
          variant="subtitle2"
          style={{
            color: colors.gray650,
            marginTop: '4px',
            textAlign: 'center',
          }}
        >
          {t('insights.edit_code_disabled_parent')}
        </Typography>
      )}
    </Box>
  );
};

CodeSelect.displayName = 'CodeSelect';

export default CodeSelect;
